import { createSelector } from '@reduxjs/toolkit';
import { stockPartRequestsLinesViewInitSelector } from './stockPartRequestsSelector';
import { PartRequestBulkCounters } from '../../common/types/commonTypes';
import { RootState } from '../store';

export const stockBulkCountersSelector = createSelector(
  stockPartRequestsLinesViewInitSelector,
  (details): Required<PartRequestBulkCounters> => {
    return {
      bulkCreatePurchaseOrderCount: details.bulkCreatePurchaseOrderCount ?? 0,
      bulkMarkAsReadyCount: details.bulkMarkAsReadyCount ?? 0,
      bulkReviewStockSourceCount: details.bulkReviewStockSourceCount ?? 0,
      bulkMarkAsCollectedCount: details.bulkMarkAsCollectedCount ?? 0,
      bulkReviewPricelistSourceCount: details.bulkReviewPricelistSourceCount ?? 0,
      bulkReturnToStockCount: details.bulkReturnToStockCount ?? 0,
    };
  },
);

export const stockBulkFilterSelector = (state: RootState) => state.stockPartRequest.stockPartRequestBulkFilters;

export const stockPartRequestBulkSelector = (state: RootState) => state.stockPartRequest.stockPartRequestBulk;
